import { DownOutlined, LoadingOutlined, PlusOutlined, SettingOutlined, UpOutlined, WarningOutlined } from '@ant-design/icons';
import type { ColDef, GridApi, SelectionChangedEvent } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { ConfigProvider, Pagination } from 'antd';
import viVN from 'antd/locale/vi_VN';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { IConditionSV2, IDetailGroup, IVConditionFilterV2 } from '../../../../../../api/groupCustomerV2/groupCustomerV2Api';
import { getListCarCompany, getSLUnitOption, type ISelectOption } from '../../../../../../api/selectOptions/selectOptionsApi';
import { NodataTable } from '../../../../../../components/NoDataTable';
import { fommatSelectOption, fommatSelectOptionUnit, formatPrice } from '../../../../../../until';
import '../../../style.scss';
import { CONDITION, type IDataFilterGroupList, type IPagination } from '../../AddGroup/AddNewGroup';
import ModalAddCustomersManually from '../../Modal/ModalAddCustomersManually';
import { useCustomerGroupContext } from '../../../indexV2';
import { CONDITIONGROUP } from '../../AddGroup/Component/PrivateGroup/AG_PrivateAutomatic';
import { AddType, ISelectedCustomer } from '../EditGroup';
import { formatNumber } from '../../../../../../services/mixin';
import ItemConditionDisplay from '../../ViewGroup/components/ItemConditionDisplay';



interface Props {
    isLoadingTableModal: boolean
    selectedIdCustomerV9: ISelectedCustomer[]
    setSelectedIdCustomerV9: React.Dispatch<React.SetStateAction<ISelectedCustomer[]>>

    //Kh có dk
    dataFilterListCondUnmatchedCustomers: IDataFilterGroupList
    memoizedColumnDefs: ColDef<any, any>[];
    tableDataCondMatchedCustomers: any[];
    tableDataCondUnmatchedCustomers: any[];

    selectedIdCondUnmatchedCustomers: Set<number>

    paginationCondMatchedCustomers: IPagination;
    paginationCondUnmatchedCustomers: IPagination;

    setSelectedIdCondUnmatchedCustomers: (data: Set<number>) => void;
    setDataFilterListCondUnmatchedCustomers: (dataFilterList: IDataFilterGroupList) => void;
    onPaginationCondUnmatchedCustomers: (page: number, pageSize: number) => void;
    //Kh có dk

    tableDataNoCondCustomer: any[];


    infoOperator: IVConditionFilterV2

    setModalCondition: (visible: boolean) => void;
    onPaginationCondMatchedCustomers: (page: number, pageSize: number) => void;

    //Kh có dk ALl
    tableDataCondCustomerAll: any[]
    paginationCondAll: IPagination
    onPaginationChangeCondAll: (page: number, pageSize: number) => void;

}

const EG_CustomerList: React.FC<Props> = ({

    isLoadingTableModal,
    //Kh có dk
    dataFilterListCondUnmatchedCustomers,
    paginationCondMatchedCustomers, paginationCondUnmatchedCustomers, tableDataCondUnmatchedCustomers,
    selectedIdCondUnmatchedCustomers,
    memoizedColumnDefs, tableDataCondMatchedCustomers,
    setSelectedIdCondUnmatchedCustomers, onPaginationCondUnmatchedCustomers, setDataFilterListCondUnmatchedCustomers,
    //Kh có dk
    tableDataNoCondCustomer, selectedIdCustomerV9,

    infoOperator,
    setSelectedIdCustomerV9,
    setModalCondition,
    onPaginationCondMatchedCustomers,

    //Kh có dk All
    tableDataCondCustomerAll,
    paginationCondAll,
    onPaginationChangeCondAll,
}) => {
    const {
        isModalLoadingSync, isLoadingListUnmatchedSync,
        handleOpenDataFields
    } = useCustomerGroupContext();

    useEffect(() => {
        let unmounted = false;
        return () => {
            unmounted = true;
        };
    }, []);

    const isRestoringSelection = useRef(false);
    const gridApiRef = useRef<GridApi | null>(null);
    // Lưu addType gốc của từng KH để không bị mất khi bỏ chọn rồi chọn lại
    const customerTypeMapRef = useRef<Map<number, AddType>>(new Map());

    const [isMore, setMore] = useState<boolean>(true)
    const [isModalAddCustomersManually, setModalAddCustomersManually] = useState<boolean>(false)
    // console.log(conditions)

    const [selectedIds, setSelectedIds] = useState<Set<Number>>(new Set());


    //------------------------------------
    // Định danh duy nhất cho mỗi row
    const getRowId = useCallback((p: { data: any }) => String(p.data.id), []);

    // --- Grid ready ---
    const onGridReady = useCallback((params: { api: GridApi }) => {
        gridApiRef.current = params.api;
    }, []);

    // --- Selection change ---
    const onSelectionChanged = useCallback((event: SelectionChangedEvent) => {
        if (isRestoringSelection.current) {
            console.log('🛑 Selection change blocked - restoring in progress');
            return;
        }

        const api = event.api;
        const selectedNodes = api.getSelectedNodes().filter(n => n.data);
        const selectedIdsOnPage = selectedNodes.map(n => Number(n.data.id));

        // console.log('🎯 Selection changed:', {
        //     selectedIdsOnPage,
        //     totalSelected: selectedNodes.length,
        //     currentPageData: infoOperator.typeCondition === CONDITIONGROUP.ALL ?
        //         tableDataCondCustomerAll.length : tableDataCondMatchedCustomers.length
        // });

        const currentPageIds = (infoOperator.typeCondition === CONDITIONGROUP.ALL ? tableDataCondCustomerAll : tableDataCondMatchedCustomers ?? []).map((row: any) => Number(row.id));

        // --- Tạo bản sao của selectedIds hiện tại ---
        const nextSet = new Set(selectedIds);

        // --- Xác định phần tử được thêm và bị xóa trên trang HIỆN TẠI ---
        const added: number[] = [];
        const removed: number[] = [];

        // Kiểm tra từng ID trên trang hiện tại
        for (const id of currentPageIds) {
            const isCurrentlySelected = selectedIdsOnPage.includes(id);
            const wasPreviouslySelected = selectedIds.has(id);

            if (isCurrentlySelected && !wasPreviouslySelected) {
                // ID mới được chọn
                added.push(id);
                nextSet.add(id);
            } else if (!isCurrentlySelected && wasPreviouslySelected) {
                // ID bị bỏ chọn
                removed.push(id);
                nextSet.delete(id);
            }
        }

        setSelectedIds(nextSet);

        // console.log('Added:', added, 'Removed:', removed);


        // handleChangeSelectIdCustomerView(nextSet);
        handleChangeSelectedCustomer(added, removed);

    }, [selectedIds, tableDataCondMatchedCustomers, tableDataCondCustomerAll]);

    //------------------------------------
    // Cập nhật map addType khi selectedIdCustomerV9 thay đổi (overwrite để đảm bảo dữ liệu API mới nhất thắng)
    // Khi KH bị bỏ chọn (xóa khỏi state), entry vẫn còn trong map với addType cuối cùng đúng
    useEffect(() => {
        selectedIdCustomerV9.forEach(c => {
            customerTypeMapRef.current.set(c.customerId, c.addType);
        });
    }, [selectedIdCustomerV9]);

    // --- Cập nhật danh sách account được chọn ---
    const handleChangeSelectedCustomer = (itemsAdd: number[] = [], itemsRemove: number[] = []) => {

        setSelectedIdCustomerV9((prev) =>
            itemsAdd.length ?
                [
                    ...prev,
                    ...itemsAdd
                        .filter((id) => !prev.some((u) => u.customerId === id))
                        .map((id) => ({
                            customerId: id,
                            // Giữ nguyên addType gốc (Manual=0 / Auto=1), không tự đổi thành Auto
                            addType: customerTypeMapRef.current.get(id) ?? AddType.Auto,
                        })),
                ] :
                itemsRemove.length ?
                    prev.filter((u) => !itemsRemove.includes(u.customerId)) :
                    prev
        );
    };

    // --- Khôi phục selection khi data mới load ---
    useEffect(() => {
        if (gridApiRef.current && (tableDataCondMatchedCustomers?.length > 0 || tableDataCondCustomerAll?.length > 0)) {
            isRestoringSelection.current = true;
            // Lấy tất cả IDs từ data hiện tại
            const currentData = infoOperator.typeCondition === CONDITIONGROUP.ALL ?
                tableDataCondCustomerAll : tableDataCondMatchedCustomers;

            const currentPageIds = currentData.map((row: any) => Number(row.id));

            // Khôi phục selection cho từng node
            gridApiRef.current.forEachNode((node: any) => {
                if (node.data) {
                    const nodeId = Number(node.data.id);
                    const shouldBeSelected = selectedIds.has(nodeId);

                    if (shouldBeSelected) {
                        node.setSelected(true, false, true);
                    } else {
                        node.setSelected(false, false, true);
                    }
                }
            });

            // Đảm bảo grid refresh để hiển thị selection
            gridApiRef.current.refreshCells({ force: true });

            setTimeout(() => {
                isRestoringSelection.current = false;
            }, 100);
        }
    }, [tableDataCondMatchedCustomers, tableDataCondCustomerAll, selectedIds, infoOperator.typeCondition, selectedIdCustomerV9]);

    useEffect(() => {
        const Ids = new Set(
            selectedIdCustomerV9.map(item => item.customerId)
        );
        setSelectedIds(Ids);
    }, [selectedIdCustomerV9])

    return (
        <div className="custom-page-css w-full flex flex-col gap-2 bg-white px-4 rounded">
            <ModalAddCustomersManually
                loadingTableModal={isLoadingTableModal}
                isOpen={isModalAddCustomersManually}
                dataFilterListCondUnmatchedCustomers={dataFilterListCondUnmatchedCustomers}
                memoizedColumnDefs={memoizedColumnDefs}
                tableDataCondUnmatchedCustomers={infoOperator.typeCondition === CONDITIONGROUP.ALL ? [] : tableDataCondUnmatchedCustomers}
                paginationCondUnmatchedCustomers={paginationCondUnmatchedCustomers}
                selectedIdCondUnmatchedCustomers={selectedIdCondUnmatchedCustomers}
                setSelectedIdCondUnmatchedCustomers={setSelectedIdCondUnmatchedCustomers}
                setDataFilterListCondUnmatchedCustomers={setDataFilterListCondUnmatchedCustomers}
                onPaginationCondUnmatchedCustomers={onPaginationCondUnmatchedCustomers}
                closeModal={setModalAddCustomersManually}
            />

            {/* Header */}
            <div className="custom-page-css flex flex-col border-b pb-2">
                <div className="custom-page-css w-full flex items-center justify-betweeen gap-2">
                    <span className='custom-page-css text-lg font-medium whiteSpace-nowrap'>Điều kiện nhóm</span>
                    <div className="custom-page-css flex items-center gap-1 cursor-pointer"
                        onClick={() => setModalCondition(true)}
                    >
                        <div className="custom-page-css flex items-center justify-center rounded-full bg-E1E4E9 p-2px ">
                            <PlusOutlined style={{ color: '#98A2B3' }} />
                        </div>
                        <span className="custom-page-css text-base text-667085 font-medium">Thiết lập điều kiện
                            <span className="custom-page-css text-base text-1890FF font-medium">({infoOperator.typeCondition === CONDITIONGROUP.ALL ? 1 : infoOperator.conditions.length} tiêu chí đang áp dụng)</span>
                        </span>
                    </div>

                </div>
                <div className="custom-page-css flex flex-col gap-1">
                    <span className='custom-page-css text-sm text-344054 font-regular'>Áp dụng cho module</span>
                    <span className='custom-page-css text-lg text-344054 font-bold'>Danh sách khách hàng</span>
                </div>

            </div>
            <div className={`${infoOperator.typeCondition !== CONDITIONGROUP.ALL ? '' : 'd-none'} custom-page-css flex flex-col border-b pb-2`}>
                <div className="custom-page-css w-full flex flex-1 items-center justify-between gap-2">
                    <div className="custom-page-css flex items-center gap-2">
                        <span className='custom-page-css text-lg font-medium whiteSpace-nowrap'>Điều kiện lọc</span>


                    </div>
                    {(isMore) ?
                        <UpOutlined className='custom-page-css text-base text-98A2B3' onClick={() => setMore(!isMore)} />
                        :
                        <DownOutlined className='custom-page-css text-base text-98A2B3' onClick={() => setMore(!isMore)} />
                    }
                </div>
                {isMore &&
                    <div className="custom-page-css flex flex-col gap-2 flex-1">
                        <div className="custom-page-css flex gap-2 flex-1">
                            <div className="custom-page-css flex flex-col gap-2 flex-1">
                                <span className='custom-page-css text-base text-344054 font-medium'>Trường</span>

                            </div>
                            <div className="custom-page-css flex flex-col gap-2 flex-1">
                                <span className='custom-page-css text-base text-344054 font-medium'>Điều kiện</span>
                            </div>
                            <div className="custom-page-css flex flex-col gap-2 flex-1">
                                <span className='custom-page-css text-base text-344054 font-medium'>Giá trị</span>
                            </div>
                        </div>
                        <div className="custom-page-css flex flex-col flex-1">
                            {
                                infoOperator.conditions.map((item, i) => (
                                    <div
                                        key={i}
                                        className="custom-page-css flex gap-2 flex-1"
                                    >
                                        <div className="custom-page-css flex flex-col gap-2 flex-1">
                                            <span className='custom-page-css text-base text-344054 font-regular'>
                                                {
                                                    infoOperator?.typeCondition === 1 && i !== 0 &&
                                                    <span className='pr-2'>  {item.logicOperator}</span>
                                                }
                                                {item.CustomerField?.label}
                                            </span>
                                        </div>
                                        <div className="custom-page-css flex flex-col gap-2 flex-1">
                                            <span className='custom-page-css text-base text-344054 font-regular'>
                                                {item.condition?.label}
                                            </span>
                                        </div>
                                        <div className="custom-page-css flex gap-2 flex-1">
                                            <ItemConditionDisplay
                                                item={item}
                                            />
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                }
            </div>

            <div className="custom-page-css flex gap-2 items-center justify-between">
                <span className="custom-page-css text-lg font-medium">Xem trước danh sách khách hàng của nhóm</span>

                <span className="custom-page-css text-FF4D4F text-base font-regular"><WarningOutlined className='custom-page-css text-sm text-FF4D4F' /> (Danh sách khách hàng sẽ thay đổi theo điều kiện)</span>
            </div>


            {/* Counter */}
            <div className="custom-page-css flex items-center justify-betweeen gap-1">
                <div className="custom-page-css flex items-center gap-1">
                    <span className="custom-page-css text-base text-4B4B4B font-regular">Đã chọn:</span>
                    <span className="custom-page-css text-base text-344054 font-regular">

                        {/* {infoOperator.typeCondition === CONDITIONGROUP.ALL ? paginationCondAll.total : paginationCondMatchedCustomers.total}  */}
                        {formatPrice(selectedIdCustomerV9.length)} khách hàng</span>
                </div>
                <div className="custom-page-css flex items-center justify-end gap-2">
                    {
                        isLoadingListUnmatchedSync ? (
                            <div className="custom-page-css flex items-center gap-1 cursor-pointer"
                            >
                                <div className="custom-page-css flex items-center justify-center  p-2px rounded-full bg-E1E4E9 "
                                >
                                    <LoadingOutlined style={{ color: '#096DD9' }} />
                                </div>
                                <span className="custom-page-css text-base text-667085 font-medium">Đang đồng bộ dữ liệu!</span>
                            </div>
                        ) : (
                            // <></>
                            <div className="custom-page-css flex items-center gap-1 cursor-pointer"
                                onClick={() => setModalAddCustomersManually(true)}
                            >
                                <div className="custom-page-css flex items-center justify-center  p-2px rounded-full bg-E1E4E9 "

                                >
                                    <PlusOutlined style={{ color: '#98A2B3' }} />
                                </div>
                                <span className="custom-page-css text-base text-667085 font-medium">Thêm khách hàng thủ công</span>
                            </div>
                        )
                    }
                    <div className="btn-input t-px-8 cursor-pointer"
                        onClick={handleOpenDataFields}
                    >
                        <div className="icon-svg">
                            <SettingOutlined />
                        </div>
                    </div>
                </div>
            </div>
            {/* Grid */}
            <div className="ag-theme-alpine custom-table-ag custom-h-modal" style={{ height: 550, width: '100%' }}>
                <AgGridReact
                    // domLayout="autoHeight"
                    className="my-auto-height-grid"
                    getRowStyle={(params: any) => ({
                        backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                    })}
                    columnDefs={memoizedColumnDefs}
                    // rowData={tableDataCondMatchedCustomers}
                    rowData={infoOperator.typeCondition === CONDITIONGROUP.ALL ? tableDataCondCustomerAll : tableDataCondMatchedCustomers}
                    rowHeight={55}
                    defaultColDef={{
                        resizable: true
                    }}
                    overlayNoRowsTemplate={NodataTable}

                    rowSelection={{ mode: 'multiRow' }} selectionColumnDef={{ pinned: 'left', lockPosition: 'left', suppressMovable: true }}
                    getRowId={getRowId}
                    onGridReady={onGridReady}
                    onSelectionChanged={onSelectionChanged}
                />
                {
                    isModalLoadingSync && (
                        <div className="table-loading-overlay">
                            <LoadingOutlined className="custom-page-css text-xl " />
                            <span className="text-sm font-medium text-344054">Đang đồng bộ dữ liệu!</span>
                        </div>
                    )
                }
            </div>

            {/* Pagination */}
            {infoOperator.typeCondition === CONDITIONGROUP.ALL
                ?
                <ConfigProvider locale={viVN}>
                    <div className="pagination-block">
                        <Pagination
                            showSizeChanger
                            current={paginationCondAll.current}
                            pageSize={paginationCondAll.pageSize}
                            total={paginationCondAll.total}
                            itemRender={(page, type, originalElement) => {
                                // Chỉ custom khi là nút số trang
                                if (type === 'page') {
                                    return <span>{formatNumber(page)}</span>;
                                }
                                // prev / next / jump-prev / jump-next giữ nguyên
                                return originalElement;
                            }}
                            className="rs-pagination"
                            onChange={onPaginationChangeCondAll}
                        />
                    </div>
                </ConfigProvider>
                :
                <ConfigProvider locale={viVN}>
                    <div className="pagination-block">
                        <Pagination
                            showSizeChanger
                            current={paginationCondMatchedCustomers.current}
                            pageSize={paginationCondMatchedCustomers.pageSize}
                            total={paginationCondMatchedCustomers.total}
                            itemRender={(page, type, originalElement) => {
                                // Chỉ custom khi là nút số trang
                                if (type === 'page') {
                                    return <span>{formatNumber(page)}</span>;
                                }
                                // prev / next / jump-prev / jump-next giữ nguyên
                                return originalElement;
                            }}
                            className="rs-pagination"
                            onChange={onPaginationCondMatchedCustomers}
                        />
                    </div>
                </ConfigProvider>

            }
        </div>
    );
};

export default React.memo(EG_CustomerList)